<form [formGroup]="addNipForm" (ngSubmit)="onAddNip()" #pTypeForm>
  <div class="main-card">
    <div class="card-header">
      <a
        class="main-btn back-btn"
        [routerLink]="['./../']"
        queryParamsHandling="preserve"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !addNipForm.valid }"
        [disabled]="!addNipForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Kreiraj NIP</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field w-100">
            <label>Zahtev broj (ručno)</label>
            <input
              type="text"
              class="w-100"
              formControlName="request_nr"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Šarža broj</label>
            <input
              type="text"
              class="w-100"
              formControlName="batch"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Datum otvaranja</label>
            <input
              type="text"
              class="w-100"
              [value]="currentDate"
              disabled
              pInputText
            />
          </div>
          <div class="field w-100">
            <div class="flex">
              <app-infinite-dropdown
                styleClass="mb-2"
                label="Partneri"
                fControlName="partner_id"
                placeholder="Izaberi partnera"
                [options]="allPartners?.data"
                [paginator]="allPartners?.pagination"
                optionLabel="company"
                optionValue="id"
                (onFilter)="getPartners(1, $event)"
                (loadMore)="getPartners($event)"
                class="w-100"
                [showSearch]="true"
              ></app-infinite-dropdown>

              <div class="flex align-items-end mb-2">
                <a
                  [routerLink]="['/partners/add']"
                  [queryParams]="{ fromPage: '/nip/add' }"
                  (click)="goToAddPage()"
                  class="main-btn ml-2"
                  ><i class="pi pi-plus ml-0"></i
                ></a>
              </div>
            </div>
          </div>
          <div class="field w-100">
            <label>Otvorio</label>
            <input
              type="text"
              class="w-100"
              [value]="currentUser.user.fname + ' ' + currentUser.user.lname"
              pInputText
              disabled
            />
            <input
              type="hidden"
              class="w-100"
              formControlName="creator_id"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Rok izrade</label>
            <p-calendar
              styleClass="w-100"
              dateFormat="dd.mm.yy"
              [showIcon]="true"
              formControlName="deadline"
              inputId="time"
            ></p-calendar>
          </div>
        </div>

        <div class="col-4">
          <div class="field w-100">
            <app-infinite-dropdown
              styleClass="mb-2"
              label="Naziv proizvoda"
              fControlName="product_id"
              placeholder="Izaberi "
              [options]="products?.data"
              [paginator]="products?.pagination"
              optionLabel="name"
              optionValue="id"
              (onFilter)="getProducts(1, $event)"
              (loadMore)="getProducts($event)"
              class="w-100"
              [showSearch]="true"
            ></app-infinite-dropdown>
          </div>
          <div class="field w-100" *ngIf="selectedProduct">
            <label>Tip proizvoda</label>
            <input
              type="text"
              [value]="selectedProduct.product_type.name"
              disabled
              class="w-100"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Ukupno vreme</label>
            <input
              type="text"
              class="w-100"
              formControlName="total_estimated_time"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Tip pakovanja</label>
            <div class="flex">
              <p-dropdown
                class="w-100"
                [options]="allPackageTypes"
                optionLabel="name"
                placeholder="Izaberi tip"
                formControlName="packaging_type_id"
                optionValue="id"
              ></p-dropdown>
              <a
                [routerLink]="['/package_types/add']"
                [queryParams]="{ fromPage: '/nip/add' }"
                (click)="goToAddPage()"
                class="main-btn ml-2"
                ><i class="pi pi-plus ml-0"></i
              ></a>
            </div>
          </div>
          <div class="field w-100 flex flex-row">
            <div class="field mb-0 w-100 mr-2">
              <label>Količina potrebno</label>
              <input
                type="text"
                class="w-100"
                formControlName="required_units"
                pInputText
              />
            </div>
            <div class="field mb-0 w-100 ml-2">
              <label>Količina planirano</label>
              <input
                type="text"
                class="w-100"
                formControlName="planned_units"
                pInputText
              />
            </div>
          </div>
          <div class="field w-100">
            <label>Status</label>
            <p-dropdown
              class="w-100"
              [options]="allStatuses"
              optionLabel="name"
              placeholder="Izaberi status"
              formControlName="status_id"
              optionValue="id"
            ></p-dropdown>
          </div>
        </div>

        <div class="col-4 flex flex-column">
          <div class="field w-100 flex-1">
            <label>Napomena</label>
            <textarea
              type="text"
              class="w-100 h-full"
              formControlName="note"
              pInputTextarea
            >
            </textarea>
          </div>
          <div class="field w-100 flex-1">
            <label>Reklamacija</label>
            <textarea
              type="text"
              class="w-100 h-full"
              formControlName="complaint"
              pInputTextarea
            >
            </textarea>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="selectedProduct">
        <div class="col-12">
          <h3 class="card-title">Redosled operacija</h3>
        </div>

        <div class="col-12">
          <ul>
            <li
              *ngFor="
                let operation of selectedProductOperations;
                let index = index
              "
            >
              <p-panel
                [toggleable]="true"
                styleClass="mb-3"
                collapsed="true"
                collapseIcon="pi pi-chevron-right"
                expandIcon="pi pi-chevron-down"
              >
                <p-header class="w-100 ml-0 p-2 panel-header">
                  <section
                    class="flex align-items-center justify-content-between"
                  >
                    <section class="flex align-items-center">
                      <h3 class="mr-3">{{ index + 1 }}.</h3>
                      <div class="field mr-3 mb-0">
                        <label>Naziv operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation.name"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Pripremno vreme</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation.prep_time"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation.operation_time"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme do sl. operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation.next_op_time"
                          disabled
                        />
                      </div>
                    </section>
                  </section>
                </p-header>

                <ul>
                  <li
                    *ngFor="
                      let suboperation of operation.suboperations;
                      let index = index
                    "
                  >
                    <section
                      class="flex align-items-center justify-content-between m-3 ml-3"
                    >
                      <section class="flex align-items-center">
                        <h3 class="mr-3">{{ index + 1 }}.</h3>
                        <div class="field mr-3">
                          <label>Naziv podoperacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.suboperation.name"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Pripremno vreme</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.suboperation.prep_time"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Vreme operacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.suboperation.operation_time"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Vreme do sl. operacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.suboperation.next_op_time"
                            disabled
                          />
                        </div>
                      </section>
                    </section>
                  </li>
                </ul>
              </p-panel>
            </li>
          </ul>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <h3 class="card-title">Istorija izmena</h3>
        </div>
        <div class="col-12"></div>
      </div>
    </div>
  </div>
</form>
